<template>
  <b-card no-body class="job-item" tag="article">
    <b-card-body class="job-item__shimmer">
      <shimmer
        v-if="imageHead"
        :height="imageHeadHeight"
        width="100%"
      ></shimmer>
    </b-card-body>
    <div class="job-item__content">
      <paragraph-shimmer :withTitle="withTitle" :justified="justified" />
    </div>
  </b-card>
</template>
<script>
import shimmer from '@/components/shimmers/shimmer'
import paragraphShimmer from '@/components/shimmers/paragraph'

export default {
  components: {
    shimmer,
    paragraphShimmer
  },
  props: {
    withTitle: {
      default: true,
      type: Boolean
    },
    justified: {
      default: false,
      type: Boolean
    },
    imageHead: {
      default: true,
      type: Boolean
    },
    imageHeadHeight: {
      default: '150px',
      type: String
    }
  }
}
</script>
